import type {FC} from 'react';

import * as S from './styles';

type Props = {
  onClick?: () => void;
  unit: string;
  weight: number;
};

export const Weight: FC<Props> = ({onClick, unit, weight}) => {
  return (
    <S.Container onClick={onClick}>
      <S.Row>
        <S.Weight>{weight}</S.Weight>
        <S.Unit>{unit}</S.Unit>
      </S.Row>
    </S.Container>
  );
};
